var app = angular.module('app-account-summary', ['app-account-service']);

app.controller('AccountSummary', ['$scope', 'accountService', function ($scope, accountService) {
    $scope.Account = '';
    $scope.Login = function () {
        accountService.Login().then(function () {
            if (accountService._account != null && accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                $scope.Account = accountService._account;
            }
        });
    };
    $scope.Logout = function () {
        //GA4
        trackEventGlobalAndLocalGA4({ 'ga4_name': 'logout', 'ga4_location': 'header' });

        accountService.Logout();
    }
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-account-summary');
        angular.bootstrap(appID, ['app-account-summary']);
    } catch (e) {
        //do nothing
    }
});